import api from 'api';

export const loadSharedAccountsPartnerAudience = api(
  'GET /api/partner-audiences/:partnerAudience/shared-accounts'
);

export const createSharedAccountPartnerAudience = api(
  'POST /api/partner-audiences/:partnerAudience/shared-accounts'
);

export const deleteSharedAccountPartnerAudience = api(
  'DELETE /api/partner-audiences/:partnerAudience/shared-accounts/:id'
);

export const loadUnusedAccountsPartnerAudience = api(
  'GET /api/partner-audiences/:partnerAudience/shared-accounts/fields/accounts'
);
